export const aboutData = {
  title: "Who I am",
  description1:
    "My name is Ankit Rajpoot, and I am a Frontend Developer with a strong focus on building intuitive, scalable, and high-performance web applications.",
  description2:
    "Proficient in modern technologies such as React and Next.js, I have been responsible for developing and maintaining comprehensive web platforms, including admin interfaces and e-commerce systems. I am committed to writing clean, maintainable code and delivering seamless, user-centered experiences. Currently, I am based in Bangalore, working with Buyeazzy, and I originate from Kanpur. I am continuously exploring emerging tools, frameworks, and design systems to advance the capabilities and standards of frontend development.",
  image: 2,
};
